(window as any).global ||= window;

export {};
